import { useMutation, useQueryClient } from "react-query";
import { AxiosInstance } from "axios";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { useClient } from "utils/client";
import { ControlContext } from "context/Controls";

interface CreateRiskGroupingTemplateInput {
  id: string;
  label: string;
  description: string;
  members: string[];
}

const createRiskGroupingTemplate = async (
  client: AxiosInstance,
  group: CreateRiskGroupingTemplateInput
) => {
  const { data } = await client.post("/risk-grouping-templates", {
    payload: group,
  });
  return data;
};

export const useCreateRiskGroupingTemplate = () => {
  const client = useClient();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { displayNotification } = useContext(ControlContext);

  const { mutate } = useMutation(
    async (group: CreateRiskGroupingTemplateInput) =>
      await createRiskGroupingTemplate(client, group),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["riskGroupingTemplates"]);
        displayNotification!(t("notification.saving.generic_success"), "");
      },
      onError: (e) => {
        displayNotification!(
          t("riskTemplate.groupings.error_create"),
          (e as Error).message,
          "error"
        );
      },
    }
  );

  return mutate;
};
